import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";

import { CurrentSiteService } from '../../../shared/services/current-site.service';
import { DataCollection } from '../../../shared/models/site-content/data-collection.model';
import { CurrentUserService } from '../../../security/current-user.service';
import { SiteHomePageService } from '../../../shared/services/site-home-page.service';
import { SiteHomePage } from '../../../shared/models/form-builder/site-home-page.model';
import { FolderPermissionService } from '../../../shared/services/folder-permission.service';
import { PermissionTestingService } from '../../../shared/services/permission-testing.service';
import { Folder } from '../../../shared/models/site-content/folder.model';
import { FolderService } from '../../../shared/services/folder.service';
import { DataCollectionService } from '../../../shared/services/data-collection.service';

@Component({
    selector: 'app-configure-home-page',
    templateUrl: './configure-home-page.component.html',
    styleUrls: ['./configure-home-page.component.scss'],
    standalone: false
})
export class ConfigureHomePageComponent implements OnInit {
    private siteHomePage: SiteHomePage = null;

    // Constructor.
    public constructor(private currentSiteService: CurrentSiteService,
        private currenteUserService: CurrentUserService,
        private siteHomePageService: SiteHomePageService,
        private folderPermissionService: FolderPermissionService,
        private permissionTestingService: PermissionTestingService,
        private folderService: FolderService,
        private dataCollectionService: DataCollectionService,
        private router: Router)
    {
    }

    // Life cycle methods.
    public ngOnInit(): void {
        // Lookup the site's home page, if any.
        let site: DataCollection = this.currentSiteService.Site;
        this.siteHomePageService.get(site.id).then(response => {
            this.siteHomePage = response;
        });
    }

    // Methods called by my HTML code.
    public get DesignHomePageDisabled(): boolean {
        let disabled: boolean = !this.currentSiteService.Site.siteIsAdministerable;

        if ((!this.currentSiteService.Site.siteIsAdministerable)) {
            if ((this.siteHomePage != null) && (this.siteHomePage.id > 0) && this.currentSiteService.Site.currentUserCanEditSiteHomePageHtml)
                disabled = false;
        }

        return disabled;
    }

    public get DesignHomePageButtonText(): string {
        // return (this.siteHomePage != null) && (this.siteHomePage.id > 0) ? 'Edit Site Home Page' : 'Design Site Home Page';
        let buttonText: string = '';
        // VNEXT-1619:  handle two cases, the original one for editing the home page and a new one for editing home page HTML fields only, the latter only if the site home page already exists.
        if (this.currentSiteService.Site.siteIsAdministerable) {
            buttonText = (this.siteHomePage != null) && (this.siteHomePage.id > 0) ? 'Edit Site Home Page' : 'Design Site Home Page'
        } else if ((this.siteHomePage != null) && (this.siteHomePage.id > 0) && this.currentSiteService.Site.currentUserCanEditSiteHomePageHtml) {
            buttonText = 'Design Site Home Page HTML';
        }

        return buttonText;
    }

    public get TestSomethingButtonText(): string {
        // Note:  the text in this message is generally meant only for developers.
        return 'Test FolderPermissionService';
    }
    public get UserIsSystemAdmin(): boolean {
        return this.currenteUserService.user.isSystemAdmin;
    }

    public get HomePageNotYetCreated(): boolean {
        return this.siteHomePage != null ? this.siteHomePage.id == 0 : true;
    }
    public get HomePageIsActive(): boolean {
        return this.siteHomePage != null ? this.siteHomePage.isActive : false;
    }
    public get DeactivateButtonText(): string {
        return (this.siteHomePage != null) && this.siteHomePage.isActive ? 'Deactivate' : 'Deactivated';
    }
    public get ActivateButtonText(): string {
        return (this.siteHomePage != null) && this.siteHomePage.isActive ? 'Activated' : 'Activate';
    }

    public get ShowEnableStructureForEndUsers(): boolean {
        return (this.siteHomePage != null) && this.siteHomePage.isActive;
    }
    public get EnableStructureForEndUsers(): boolean {
        return this.currentSiteService.Site.enableStructureForEndUsers;
    }
    public set EnableStructureForEndUsers(value: boolean) {
        this.currentSiteService.Site.enableStructureForEndUsers = value;
    }

    // Handle control events.
    public designHomePageClicked(): void {
        // VNEXT-1619:  handle different routes for editing a site home page or only editing an existing home page's HTML fields only.
        let routeForNavigation: string = this.currentSiteService.Site.siteIsAdministerable ? '/design-homepage' : '/design-homepage-html';
        // Navigate to the the design home page route.
        //let relativeUrl: string = this.router.url.replace('/summary', '/design-homepage');
        let relativeUrl: string = this.router.url.replace('/summary', routeForNavigation);
        this.router.navigateByUrl(relativeUrl).then(result => {
            // Nothing more to do here.
        });
    }
    public deactivateSiteHomePage(): void {
        if (this.siteHomePage != null) {
            this.siteHomePage.isActive = false;
            this.siteHomePageService.save(this.siteHomePage).then(response => {
                this.siteHomePage = response;
            });
        }        
    }
    public activateSiteHomePage(): void {
        if (this.siteHomePage != null) {
            this.siteHomePage.isActive = true;
            this.siteHomePageService.save(this.siteHomePage).then(response => {
                this.siteHomePage = response;
            });
        }        
    }

    public enableStructureForEndUsersToggled(): void {
        this.dataCollectionService.enableStructureForEndUser(this.currentSiteService.Site.id, this.currentSiteService.Site.enableStructureForEndUsers).then(unusedResponse => {
            // Note:  nothing to do here by design.
        });
    }

    public testSomethingClicked(): void {
        // Get the current site's root folder Id.
        let rootFolder: Folder = this.currentSiteService.Site.getRootFolder();

        let objectIds: number[] = [rootFolder.dataCollectionId];
        if ((rootFolder.childFolders != null) && (rootFolder.childFolders.length > 1)) {
            objectIds.push(rootFolder.childFolders[0].id);
            objectIds.push(rootFolder.childFolders[1].id);

            this.folderService.getWithPagination(rootFolder.childFolders[0].id).then(fullyLoadedfolder => {
                if ((fullyLoadedfolder != null) && (fullyLoadedfolder.formInstances != null) && (fullyLoadedfolder.formInstances.length > 0)) {
                    objectIds.push(fullyLoadedfolder.formInstances[0].id);

                    this.permissionTestingService.testPermissionsUsingObjects(objectIds);
                }
            });
        }
        //this.folderPermissionService.testServiceUsingObjects(objectIds);
        //this.permissionTestingService.testPermissionsUsingObjects(objectIds);
    }
}
